export class CanadaPostAddressDetails {
  Id: string;
  SubBuilding: string;
  BuildingNumber: string;
  Street: string;
  Line1: string;
  POBoxNumber: string;
  City: string;
  ProvinceName: string;
  ProvinceCode: string;
  PostalCode: string;
}
